import { HStack, Kbd, KbdProps } from "@chakra-ui/react"
import { parseKeyControl } from "@pathwright/utils/src/keyboard/useKeyControl"
import { Fragment } from "react"
import { KeyControl } from "./types"

function KeyControls({
  keyControl,
  ...kbdProps
}: { keyControl: KeyControl } & KbdProps) {
  // From Chakra's guidelines: "All shortcuts should do their best to match what appears on the user’s keyboard."
  // hence the use of lower and upper case transforms.
  const keys = [
    ...parseKeyControl(keyControl).modifiers.map((k) => k.toLowerCase()),
    parseKeyControl(keyControl).keyName.toUpperCase()
  ]

  return (
    <HStack gap={1}>
      {keys.map((key, index) => (
        <Fragment key={key}>
          {index > 0 && <span>+</span>}
          <Kbd
            bg="transparent"
            color="whiteAlpha.800"
            borderColor="whiteAlpha.400"
            {...kbdProps}
          >
            {key}
          </Kbd>
        </Fragment>
      ))}
    </HStack>
  )
}

export default KeyControls
